import React, { useState, useEffect } from 'react';
import { handleLogout } from '../api/auth';
import { useNavigate } from 'react-router-dom';
import { retrieveToken } from './../hooks/use-token';

const Logout = () => {
  
    const nav = useNavigate();

    useEffect(() => {
    
        const tokenApi = retrieveToken();

        if (tokenApi) {

            handleLogout(tokenApi).then(function(result) {
                localStorage.clear();
                nav("/");
            });

        } else {
            nav("/");
        }

    });

};

export default Logout;